import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Checkbox, CheckboxProps } from "@material-ui/core";

type Props = {
  checked: boolean;
  onChange?: CheckboxProps["onChange"];
  label: string;
  name?: string;
};

export const CheckboxWithLabel: React.VFC<Props> = (props) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={props.checked}
          onChange={props.onChange}
          name={props.name}
          color="secondary"
        />
      }
      label={props.label}
      classes={{
        root: classes.root,
        label: classes.label,
      }}
    />
  );
};

const useStyles = makeStyles({
  root: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  label: {
    whiteSpace: "nowrap",
    textAlign: "left",
  },
});
